<template>
  <div class="avisosTopBarWrapper" :class="{ 'bg-light' : opened }" >
    <div @click="toggleAvisosDropdown()">
      <font-awesome-icon icon="bell" :class="{'text-light': !opened, 'text-primary': opened}" class="avisosTopButton"/>
      <span v-if="avisosNuevos.length > 0" class="badge badge-danger badge-avisos-topbar">{{ avisosNuevos.length }}</span>
    </div>
    <div v-if="opened" class="dropdownAvisosTopBar bg-light border-left border-right border-bottom shadow">
      <ul>
        <li v-for="aviso in avisosNuevos" :key="aviso.id" class="border-bottom small" @click="goToObject(aviso)">
          <h3>{{ aviso.tipoObjetoTexto }}</h3>
          {{ aviso.descripcion|removeHtml|truncate }}
        </li>
        <li v-if="avisosNuevos.length == 0">No hay avisos sin leer</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      opened: false
    }
  },
  computed: {
    ...mapGetters({
      avisosNuevos: 'avisosNuevos',
      urlBase: 'urlBase'
    })
  },
  methods: {
    toggleAvisosDropdown() {
      this.opened = !this.opened
    },
    goToObject(aviso) {
      console.log(aviso)
      let to = {}
      switch(aviso.tipoObjeto) {
        case 1:
          to = { 'name': 'yo' }
          break;
        case 7:
          to = { 'name': 'poliza', params: { id: aviso.objeto }}
          break;
        case 10:
          to = { 'name': 'recibo', params: { id: aviso.objeto }}
          break;
        case 13:
          to = { 'name': 'siniestro', params: { id: aviso.objeto }}
          break;
        case 160:
          to = { 'name': 'proyecto', params: { id: aviso.objeto }}
          break;
      }
      this.opened = false
      this.$router.push(to)
        let url = this.urlBase + 'incidenciasClientes/' + aviso.id;
        let data = {
            situacion: 2
        };
        let options = {};
        this.$http.put(url, data, options).then(
          (response) => {
            console.log("OK")
            let payload = {
              params: {
                'sort': 'incidenciaCliente.fechaCreacion',
                'usuarioWebCliente': 1,
                'inverse': true,
                'page': 1,
                'limit': 100
              },
              callbackOk: (responses) => {
                this.loading = false
              }
            }
            this.$store.dispatch("loadAvisos", payload)
          },
          (error) => {
          }
        )
    }
  }
}
</script>

<style scoped>
.avisosTopBarWrapper {
  height: 45px; 
  margin-right: 5px;
}
.avisosTopButton {
  padding-left: 10px; 
  padding-right: 10px; 
  height: 45px;
  width: 35px;
  display: inline-block;
  cursor: pointer;
}
.dropdownAvisosTopBar {
  position: absolute;
  width: 100%;
  max-width: 400px;
  height: 500px;
  overflow-y: auto;
  right: 0;
  top: 40px;
  z-index: 2000;
  border-width: 2px!important;
}
.dropdownAvisosTopBar > ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.dropdownAvisosTopBar > ul > li {
  padding: 10px;
  cursor: pointer;
}
.dropdownAvisosTopBar > ul > li:hover {
  background-color: #EEE;
}
.dropdownAvisosTopBar > ul > li > h3 {
  font-size: 1.3em;
  margin: 0;
}
.badge-avisos-topbar {
  border-radius: 10px!important; 
  position: absolute!important;
  margin-left: -15px!important;
  margin-top: 4px!important;
  padding-top: 2px!important;
  padding-bottom: 2px!important;
  padding-left: 4px!important;
  padding-right: 4px!important;
}

</style>

